import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import countriesJsonEn from 'i18n-iso-countries/langs/en.json';
import countriesJsonPl from 'i18n-iso-countries/langs/pl.json';
import languagesJsonEn from '@cospired/i18n-iso-languages/langs/en.json';
import languagesJsonPl from '@cospired/i18n-iso-languages/langs/pl.json';
import * as i18nIsoCountries from 'i18n-iso-countries/index';
import * as i18nIsoLanguages from '@cospired/i18n-iso-languages/index';
import { IconRegisterService } from '../../core/services/icon-register/icon-register.service';
import { register } from 'swiper/element';
import { AccountDataService } from '../../core/services/auth/account-data.service';
import { TranslateService } from '@ngx-translate/core';
import { ELanguageCode } from '../utils/enums/country.enum';
import { detectLanguageFromUrl } from '../utils/language.utils';

@Injectable()
export class InitializeService {
  readonly #iconRegister = inject(IconRegisterService);
  readonly #accountDataService = inject(AccountDataService);
  readonly #translate = inject(TranslateService);
  readonly #platformId = inject(PLATFORM_ID);

  initializeApp(): void {
    this.#registerI18n();
    this.#registerIcons();
    this.#accountDataService.refreshData();
    this.#registerSwiper();
    this.#setAvailableTranslateLanguages();
    this.#initializeLanguageFromUrl();
  }

  #initializeLanguageFromUrl(): void {
    if (isPlatformBrowser(this.#platformId)) {
      const url = window.location.pathname;
      const detectedLang = detectLanguageFromUrl(url);
      if (detectedLang) {
        this.#translate.setFallbackLang(detectedLang);
      } else {
        this.#translate.setFallbackLang(ELanguageCode.PL);
      }
    }
  }

  #registerI18n(): void {
    i18nIsoCountries.registerLocale(countriesJsonEn);
    i18nIsoCountries.registerLocale(countriesJsonPl);
    i18nIsoLanguages.registerLocale(languagesJsonEn);
    i18nIsoLanguages.registerLocale(languagesJsonPl);
  }

  #registerIcons(): void {
    this.#iconRegister.registerIcons();
  }

  #registerSwiper = (): void => register();

  #setAvailableTranslateLanguages = (): void =>
    this.#translate.addLangs([ELanguageCode.EN, ELanguageCode.PL]);
}
